module.exports = function() {
	return new Worker(__webpack_public_path__ + "7325311df0010cbd8d08.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader!./app/plugins/GA/lib/ga/GAWorker.js
// module id = 695
// module chunks = 0